var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from "classnames";
import React from "react";
import { Marker } from "react-map-gl";
const MarkerStyles = {
  base: "relative min-w-[2.5rem] rounded-md border px-2 py-1 text-sm hover:scale-110 transition font-semibold",
  beakBase: "[--peak-size:0.5rem] before:h-[--peak-size] before:w-[--peak-size] before:bottom-[calc((var(--peak-size)+2px)/-2)] before:block before:absolute before:inset-x-1/2 before:-translate-x-1/2 before:rotate-45 before:border-b before:border-r before:transition",
  states: {
    default: "text-neutral-950 bg-white before:bg-white border-neutral-400 before:border-neutral-400 lg:hover:bg-primary-300 lg:hover:before:bg-primary-300 lg:hover:border-neutral-950 lg:hover:before:border-neutral-950",
    active: "text-white bg-neutral-950 before:bg-neutral-950 border-neutral-950 before:border-neutral-950"
  }
};
export const MapMarker = _a => {
  var onClick = _a.onClick,
    children = _a.children,
    _a$anchor = _a.anchor,
    anchor = _a$anchor === void 0 ? "bottom" : _a$anchor,
    price = _a.price,
    selected = _a.selected,
    props = __rest(_a, ["onClick", "children", "anchor", "price", "selected"]);
  return /*#__PURE__*/React.createElement(Marker, Object.assign({}, props, {
    anchor: anchor,
    style: {
      zIndex: selected ? "2" : "1"
    },
    onClick: e => {
      e.originalEvent.stopPropagation();
      onClick && onClick(e);
    }
  }), price && /*#__PURE__*/React.createElement("div", {
    className: getPopupStyles(selected)
  }, price), children, !price && !children && /*#__PURE__*/React.createElement("svg", {
    className: getPinStyles(selected),
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4854 6.18124C26.6885 8.38409 27.9485 11.3574 27.999 14.4725C28.0496 17.5875 26.8866 20.6001 24.7561 22.8732L24.4854 23.1532L18.8281 28.8092C18.1102 29.5266 17.1466 29.9443 16.1323 29.9777C15.118 30.0112 14.1289 29.6578 13.3654 28.9892L13.1734 28.8092L7.51474 23.1519C5.26429 20.9015 4 17.8492 4 14.6666C4 11.484 5.26429 8.43169 7.51474 6.18124C9.76519 3.93079 12.8175 2.6665 16.0001 2.6665C19.1827 2.6665 22.235 3.93079 24.4854 6.18124ZM16.0001 10.6666C15.4748 10.6666 14.9546 10.77 14.4693 10.9711C13.984 11.1721 13.5431 11.4667 13.1716 11.8382C12.8002 12.2096 12.5056 12.6505 12.3046 13.1358C12.1035 13.6211 12.0001 14.1413 12.0001 14.6666C12.0001 15.1919 12.1035 15.712 12.3046 16.1973C12.5056 16.6826 12.8002 17.1236 13.1716 17.495C13.5431 17.8664 13.984 18.1611 14.4693 18.3621C14.9546 18.5631 15.4748 18.6666 16.0001 18.6666C17.0609 18.6666 18.0784 18.2452 18.8285 17.495C19.5786 16.7449 20.0001 15.7274 20.0001 14.6666C20.0001 13.6057 19.5786 12.5883 18.8285 11.8382C18.0784 11.088 17.0609 10.6666 16.0001 10.6666Z",
    fill: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
function getPopupStyles(selected) {
  const states = MarkerStyles.states;
  return classNames(MarkerStyles.base, MarkerStyles.beakBase, selected ? states.active : states.default);
}
function getPinStyles(selected) {
  return classNames("h-8 w-8 transition-transform hover:scale-125 stroke-neutral-950", selected ? "text-neutral-950" : "text-primary-300 hover:text-primary-100");
}